module.exports = __webpack_public_path__ + "static/media/15 - KAYTRANADA - 10 percent.405849f2.mp3";